import type { Environment } from '@highereducation/dynamic-experience';

const SHORTCODE_ENVIRONMENTS: readonly Environment[] = ['prod', 'int'];

export function resolveShortcodeEnvironment(
  raw: unknown,
  fallback: Environment,
): Environment {
  const value = typeof raw === 'string' ? (raw.trim() as Environment) : '';
  return value && SHORTCODE_ENVIRONMENTS.includes(value) ? value : fallback;
}
